import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
// import * as actions from '../../actions'
import {
  renderTextField,
  renderSelectField,
  renderDatePicker,
  renderAutoComplete
} from '../auth/form_helpers'

import '../../style/style.css';

import RaisedButton from 'material-ui/RaisedButton'
// import SelectField from 'material-ui/SelectField';
// import Menu from 'material-ui/Menu';
// import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import MenuItem from 'material-ui/MenuItem';
// import Checkbox from 'material-ui/Checkbox';
// import Divider from 'material-ui/Divider';
// import TextField from 'material-ui/TextField'
// import DatePicker from 'material-ui/DatePicker';
import Paper from 'material-ui/Paper';
// import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';

import ActionDelete from 'material-ui/svg-icons/action/delete';
import ActionLaunch from 'material-ui/svg-icons/action/launch';
import ContentClear from 'material-ui/svg-icons/content/clear';

// import * as actionCreator from '../../actions'

// const uuidv4 = require('uuid/v4');

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
  pt15: {
    paddingTop: 15,
  },
};

// var validQTypes = []
var length = 0;

class TbForm extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openPopover: false
    }
  }

  /*
  handlePopoverClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      openPopover: true,
      anchorEl: event.currentTarget,
    });
  }

  handleRequestPopoverClose = () => {
    this.setState({
      openPopover: false,
    });
  }
  */

  componentDidMount() {
  }

  componentWillMount() {
  }

  componentWillUnmount() {
  }

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert alert-danger">
        <strong>Oops: </strong>{this.props.errorMessage}
      </div>
    }
  }

  handlePId = (selectedItem) => {
      let items = selectedItem.value.props.value.split("|")
      this.props.change('idNewId', items[1].trim())
  }

  renderBase(type) {
    // console.log(this.props.tracker)
    let datasource = []
    let dataSourceConfig = {
      text: 'text',
      value: 'value',
    };
    if (typeof this.props.autocomplete !== 'undefined') {
      datasource = [];
      if (this.props.autocomplete.length > 0) {
        this.props.autocomplete.map((option, index) => {
          return datasource.push(
            {
              text: option.name,
              value: (
                <MenuItem key={index} value={option.name + ' | ' + option.id} primaryText={option.name} />
              ),
            },
          )
        })
      }
    }

    const fetch = (target, querystring, autocomplete) => {
      this.props.fetchMessage(target, querystring, autocomplete)
    };
    if (typeof this.props.tracker !== 'undefined') {
      if (this.props.tracker.values.name === null) {
        function getAutoComplete(event) {
          if (typeof document.activeElement !== 'undefined' && typeof document.activeElement.name !== 'undefined' && typeof document.activeElement.value !== 'undefined' && length !== document.activeElement.value.length && document.activeElement.name === 'idPersonNew') {
            length = document.activeElement.value.length
            let querystring = document.activeElement.value;
            fetch('/persons', '?q='+querystring, 'autocomplete3')
            window.removeEventListener("keyup", getAutoComplete);
          }
        }
        window.addEventListener("keyup", getAutoComplete)
      }
    }
    if (this.props.affairinfos.name === null) {
        return <Paper zDepth={0}>
          <Field
            className="personAutocomplete"
            component={renderAutoComplete}
            label="személy"
            name="idPersonNew"
            dataSource={datasource}
            dataSourceConfig={dataSourceConfig}
            onNewRequest={this.handlePId}
          >
          </Field>
        </Paper>
    }
  }

  renderNoti() {
    if(typeof this.props.affairinfos.notification === 'undefined' && typeof this.props.affairinfos.automatedReason !== 'undefined' && this.props.affairinfos.automatedReason !== null) {
      return void(0)
    } else if (typeof this.props.affairinfos.notification !== 'undefined') {
      return <Field
                    className={this.renderAutomatedDisabler() ? "itsDisabled itsNotAnInput" : "ac dateInput"}
                    component={renderDatePicker}
                    label="értesítve"
                    floatingLabelText="értesítve"
                    hintText="értesítve"
                    type="text"
                    style={{width: 120}}
                    defaultDate={new Date(this.props.affairinfos.notification)}
                    disabled={this.renderAutomatedDisabler()}
                    name="notification" />
    } else {
      return <Field
                    className={this.renderAutomatedDisabler() ? "itsDisabled itsNotAnInput" : "ac dateInput"}
                    component={renderDatePicker}
                    label="értesítve"
                    floatingLabelText="értesítve"
                    hintText="értesítve"
                    type="text"
                    style={{width: 120}}
                    disabled={this.renderAutomatedDisabler()}
                    name="notification" />
    }
  }

  renderAutomatedDisabler() {
    if (typeof this.props.affairinfos.automatedReason !== 'undefined' && this.props.affairinfos.automatedReason !== null) {
      return true;
    } else {
      return false;
    }
  }

  renderCreationDay() {
    if (typeof this.props.affairinfos.creation !== 'undefined') {
      return <div>
              <Field
                className={
                  this.renderAutomatedDisabler() ? "itsDisabled itsNotAnInput" 
                  : typeof this.props.tracker !== 'undefined' ?
                      typeof this.props.tracker.values !== 'undefined' ?
                        typeof this.props.tracker.values.creation !== 'undefined' ?
                          this.props.tracker.values.creation === null ? 'deleted dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      : 'ac dateInput'
                    : 'ac dateInput'
                }
                component={renderDatePicker}
                label="létrehozás dátuma"
                floatingLabelText="létrehozás dátuma"
                hintText="létrehozás dátuma"
                type="text"
                style={{width: 120}}
                defaultDate={new Date(this.props.affairinfos.creation)}
                disabled={this.renderAutomatedDisabler()}
                name="creation" />
              <Field
                component={renderTextField}
                className="dateText"
                floatingLabelText=""
                name="creation"
                type="text"
              />
              {
                this.renderAutomatedDisabler() ? void(0)
                : typeof this.props.tracker !== 'undefined' ?
                    typeof this.props.tracker.values !== 'undefined' ?
                      typeof this.props.tracker.values.creation !== 'undefined' ?
                        this.props.tracker.values.creation !== null ? (<div className="">
                            <IconButton onClick={this.delete("creation")} className="deleteIcon">
                              <ContentClear />
                            </IconButton>
                          </div>)
                        : void(0)
                      : void(0)
                    : void(0)
                  : void(0)
              }
            </div>
    } else {
      return <div>
              <Field
                className={
                  this.renderAutomatedDisabler() ? "itsDisabled itsNotAnInput" 
                  : typeof this.props.tracker !== 'undefined' ?
                      typeof this.props.tracker.values !== 'undefined' ?
                        typeof this.props.tracker.values.creation !== 'undefined' ?
                          this.props.tracker.values.creation === null ? 'deleted dateInput'
                          : 'ac dateInput'
                        : 'ac dateInput'
                      : 'ac dateInput'
                    : 'ac dateInput'
                }
                component={renderDatePicker}
                label="létrehozás dátuma"
                floatingLabelText="létrehozás dátuma"
                hintText="létrehozás dátuma"
                defaultDate={new Date()}
                type="text"
                style={{width: 120}}
                disabled={this.renderAutomatedDisabler()}
                name="creation" />
              <Field
                component={renderTextField}
                className="dateText"
                floatingLabelText=""
                name="creation"
                type="text"
              />
              {
                this.renderAutomatedDisabler() ? void(0)
                : typeof this.props.tracker !== 'undefined' ?
                    typeof this.props.tracker.values !== 'undefined' ?
                      typeof this.props.tracker.values.creation !== 'undefined' ?
                        this.props.tracker.values.creation !== null ? (<div className="">
                            <IconButton onClick={this.delete("creation")} className="deleteIcon">
                              <ContentClear />
                            </IconButton>
                          </div>)
                        : void(0)
                      : void(0)
                    : void(0)
                  : void(0)
              }
            </div>
    }
  }

  delete (text) {
    return () => {
        this.props.change(text, null)
      //this.props.onSubmit(this.refs.user.getValue(), this.refs.password.getValue())
    }
  }

  render() {
    if(typeof this.props.affairinfos !== 'undefined' && typeof this.props.affaircategories !== 'undefined' && typeof this.props.affairstatus !== 'undefined') {
      const {handleSubmit} = this.props
      return (
        <div>
            {this.renderAlert()}
            <form onSubmit={handleSubmit} style={styles.pt15} className='formFormat' >
              <div className="full">
                <div style={{paddingTop: 16}}>
                  <IconButton
                    iconStyle={styles.smallIcon}
                    style={styles.m15}
                    href={"/persons/"+this.props.affairinfos.personId} target="_blank"
                  >
                    <ActionLaunch />
                  </IconButton>
                  <a href={"/persons/"+this.props.affairinfos.personId} target="_blank">{this.props.affairinfos.personName}</a>
                </div>
              </div>
              <div className='flexContainer' style={{paddingTop: 60}}>
                <Paper zDepth={1}>
                  <label>TB ügy:</label>
                  <br />
                  {this.renderBase('type')}
                  <Field
                    className="hidden"
                    style={{
                      display: 'none'
                    }}
                    component={renderTextField}
                    name="id"
                    type="hidden"
                  />
                  <Field
                    className="hidden"
                    style={{
                      display: 'none'
                    }}
                    component={renderTextField}
                    name="idNewId"
                    type="hidden"
                  />
                  <Field
                    className="hidden"
                    style={{
                      display: 'none'
                    }}
                    component={renderTextField}
                    name="item"
                    type="hidden"
                  />
                  <Field
                    className={this.renderAutomatedDisabler() ? "itsDisabled itsNotAnInput " : ""}
                    component={renderTextField}
                    floatingLabelText="ügy megnevezése"
                    disabled={this.renderAutomatedDisabler()}
                    multiLine={true}
                    rows={1}
                    rowsMax={4}
                    name="subject"
                    type="text"/>
                  {this.renderCreationDay()}
                  <br />
                  {this.renderNoti()}
                  <Field
                    component={renderTextField}
                    className="dateText"
                    floatingLabelText=""
                    name="notification"
                    type="text"
                  />
                </Paper>

                <Paper zDepth={1}>
                  <label>Előzmények:</label>
                  <br />
                  {
                    this.props.affairinfos.history.map((option, index) => {
                      return <div key={index} className="horizontal">
                        <Field
                          className={this.renderAutomatedDisabler() ? "itsDisabled itsNotAnInput " : "ac"}
                          component={renderSelectField}
                          floatingLabelText={"státusz:"}
                          name={"history.["+index+"].status"}
                          disabled={this.renderAutomatedDisabler()}
                        >
                          {
                            this.props.affairstatus.map((option, index) => {
                              return <MenuItem key={index} value={option.value} primaryText={option.value} />
                            })
                          }
                        </Field>
                        <Field
                          className={this.renderAutomatedDisabler() ? "itsNotAnInput itsDisabled" : "itsNotAnInput"}
                          component={renderDatePicker}
                          inputStyle={{width: 100}}
                          floatingLabelText={"kezdete:"}
                          name={"history.["+index+"].date"}
                          defaultDate={new Date(this.props.affairinfos.history[index].date)}
                          type="text"
                          style={{width: 100}}
                        />
                      </div>
                    })
                  }
                  <div className="horizontal">
                    <Field
                      className={this.renderAutomatedDisabler() ? "itsDisabled itsNotAnInput" : "ac"}
                      component={renderSelectField}
                      floatingLabelText="státusz"
                      disabled={this.renderAutomatedDisabler()}
                      style={this.renderAutomatedDisabler() ? {
                        display: 'none'
                      } : {}}
                      name="historynew.status"
                    >
                      {
                        this.props.affairstatus.map((option, index) => {
                          return <MenuItem key={index} value={option.value} primaryText={option.value} />
                        })
                      }
                    </Field>
                  </div>
                  <Field
                    className={this.renderAutomatedDisabler() ? "itsNotAnInput itsDisabled" : "itsNotAnInput"}
                    component={renderTextField}
                    floatingLabelText="határozat"
                    disabled={this.renderAutomatedDisabler()}
                    style={this.renderAutomatedDisabler() ? {
                      display: 'none'
                    } : {}}
                    multiLine={true}
                    rows={1}
                    rowsMax={4}
                    name="resolution"
                    type="text"/>
                </Paper>

                {
                  typeof this.props.affairinfos.automatedReason !== 'undefined' ?
                    this.props.affairinfos.automatedReason !== null ?
                      typeof this.props.affairinfos.comments === 'undefined' ?
                        <Paper zDepth={1}>
                          <label>Megjegyzések:</label>
                          <br />
                          {
                            this.props.affairinfos.comments.map((option, index) => {
                              if (option !== null && option.text !== null) {
                                return <div key={index} className={this.props.tracker.values.comments[index].text === null ? 'hidden horizontal' : 'shw horizontal'}>
                                  <Field
                                    className={this.renderAutomatedDisabler() ? "itsNotAnInput itsDisabled itsAWeirdAnInput" : "itsNotAnInput itsAWeirdAnInput"}
                                    component={renderTextField}
                                    name={"comments.["+index+"].text"}
                                    floatingLabelText={(index+1)+". megjegyzés ("+option.time.substring(0,10)+"):"}
                                    multiLine={true}
                                    disabled={this.renderAutomatedDisabler()}
                                    rows={1}
                                    rowsMax={4}
                                    type="text"
                                  />
                                  <IconButton
                                    iconStyle={styles.smallIcon}
                                    style={styles.small}
                                    onMouseDown={this.delete("comments.["+index+"].text")}
                                  >
                                    <ActionDelete />
                                  </IconButton>
                                  {/*
                                  <Field
                                    className='itsNotAnInput'
                                    component={renderTextField}
                                    disabled={true}
                                    floatingLabelText={"dátum:"}
                                    name={"comments.["+index+"].time"}
                                    type="text"
                                    style={{width: 190}}
                                  />
                                  */}
                                </div>
                              } else {
                                return void(0)
                              }
                            })
                          }
                          <div className="horizontal">
                            <Field
                              className={this.renderAutomatedDisabler() ? "itsNotAnInput itsDisabled" : "itsNotAnInput"}
                              component={renderTextField}
                              floatingLabelText="új megjegyzés"
                              hintText="új megjegyzés"
                              type="text"
                              disabled={this.renderAutomatedDisabler()}
                              multiLine={true}
                              rows={1}
                              rowsMax={4}
                              name="commentsnew.text" />
                          </div>
                          {/*}
                          <div>
                            <Field
                              component={renderTextField}
                              floatingLabelText="megjegyzés"
                              name="comment"
                              type="text"
                            />
                          </div>
                          */}
                        </Paper>
                      : void(0)
                    : void(0)
                  : <Paper zDepth={1}>
                      <label>Megjegyzések:</label>
                      <br />
                      {
                        this.props.affairinfos.comments.map((option, index) => {
                          if (option !== null && option.text !== null) {
                            return <div key={index} className={this.props.tracker.values.comments[index].text === null ? 'hidden horizontal' : 'shw horizontal'}>
                              <Field
                                className={this.renderAutomatedDisabler() ? "itsNotAnInput itsDisabled itsAWeirdAnInput" : "itsNotAnInput itsAWeirdAnInput"}
                                component={renderTextField}
                                name={"comments.["+index+"].text"}
                                floatingLabelText={(index+1)+". megjegyzés ("+option.time.substring(0,10)+"):"}
                                multiLine={true}
                                disabled={this.renderAutomatedDisabler()}
                                rows={1}
                                rowsMax={4}
                                type="text"
                              />
                              <IconButton
                                iconStyle={styles.smallIcon}
                                style={styles.small}
                                onMouseDown={this.delete("comments.["+index+"].text")}
                              >
                                <ActionDelete />
                              </IconButton>
                              {/*
                              <Field
                                className='itsNotAnInput'
                                component={renderTextField}
                                disabled={true}
                                floatingLabelText={"dátum:"}
                                name={"comments.["+index+"].time"}
                                type="text"
                                style={{width: 190}}
                              />
                              */}
                            </div>
                          } else {
                            return void(0)
                          }
                        })
                      }
                      <div className="horizontal">
                        <Field
                          className={this.renderAutomatedDisabler() ? "itsNotAnInput itsDisabled" : "itsNotAnInput"}
                          component={renderTextField}
                          floatingLabelText="új megjegyzés"
                          hintText="új megjegyzés"
                          type="text"
                          disabled={this.renderAutomatedDisabler()}
                          multiLine={true}
                          rows={1}
                          rowsMax={4}
                          name="commentsnew.text" />
                      </div>
                      {/*}
                      <div>
                        <Field
                          component={renderTextField}
                          floatingLabelText="megjegyzés"
                          name="comment"
                          type="text"
                        />
                      </div>
                      */}
                    </Paper>
                }
                <div style={{display: 'none'}}>
                  <Paper  zDepth={1} className='flexEnd p15'>
                    <RaisedButton className="PersonFormSubmitButton" type="submit" label="mentés" primary={true} labelColor={'#FFFFFF'}/>
                  </Paper>
                </div>
              </div>
            </form>
        </div>
      )
    } else{
      return (
        <div>
            {this.renderAlert()}
            <form>
              <div>
              </div>
            </form>
        </div>
      )
    }
  }
}

const validate = values => {
  const errors = {}

  if (values.password !== values.passwordConfirmation) {
    errors.password = 'Passwords must match'
  }
    /*
  if (!values.email) {
    errors.email = 'Please enter an email'
  }
    */
  if (!values.password) {
    errors.password = 'Please enter a password'
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Please confirm your password'
  }

  return errors
}

TbForm = reduxForm({
  form: 'tbform',
  validate
})(TbForm)

// You have to connect() to any reducers that you wish to connect to yourself
TbForm = connect(
  state => ({
    initialValues: state.tb.thisaffair // pull initial values from reducer
  })//,
  //{ load: loadAccount }               // bind account loading action creator
)(TbForm)

export default TbForm


// WEBPACK FOOTER //
// ./src/components/tb/tb_form.js